module.exports = __webpack_public_path__ + "img/mb_video_bt.4650a6a9.png";